import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  private titleSubject = new BehaviorSubject<string>('Título Padrão');
  title$ = this.titleSubject.asObservable();

  private showNavSubject = new BehaviorSubject<boolean>(true);
  showNav$ = this.showNavSubject.asObservable();

  setTitle(title: string) {
    this.titleSubject.next(title);
  }

  setShowNav(show: boolean) {
    this.showNavSubject.next(show)
  }
}
